// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--lU7l1";
export var footerWrapper = "footer-module--footerWrapper--aStU2";
export var footerWrapperColumn = "footer-module--footerWrapperColumn--gycxg";